'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

require('./material-icon-select.scss');

var _materialIconsDialog = require('./material-icons-dialog.controller');

var _materialIconsDialog2 = _interopRequireDefault(_materialIconsDialog);

var _materialIconSelectTpl = require('./material-icon-select.tpl.html');

var _materialIconSelectTpl2 = _interopRequireDefault(_materialIconSelectTpl);

var _materialIconsDialogTpl = require('./material-icons-dialog.tpl.html');

var _materialIconsDialogTpl2 = _interopRequireDefault(_materialIconsDialogTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/* eslint-disable import/no-unresolved, import/default */

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.directives.materialIconSelect', []).controller('MaterialIconsDialogController', _materialIconsDialog2.default).directive('tbMaterialIconSelect', MaterialIconSelect).name;

/*@ngInject*/

function MaterialIconSelect($compile, $templateCache, $document, $mdDialog) {

    var linker = function linker(scope, element, attrs, ngModelCtrl) {
        var template = $templateCache.get(_materialIconSelectTpl2.default);
        element.html(template);

        scope.tbRequired = angular.isDefined(scope.tbRequired) ? scope.tbRequired : false;
        scope.icon = null;

        scope.updateView = function () {
            ngModelCtrl.$setViewValue(scope.icon);
        };

        ngModelCtrl.$render = function () {
            if (ngModelCtrl.$viewValue) {
                scope.icon = ngModelCtrl.$viewValue;
            }
            if (!scope.icon || !scope.icon.length) {
                scope.icon = 'more_horiz';
            }
        };

        scope.$watch('icon', function () {
            scope.updateView();
        });

        scope.openIconDialog = function ($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'MaterialIconsDialogController',
                controllerAs: 'vm',
                templateUrl: _materialIconsDialogTpl2.default,
                parent: angular.element($document[0].body),
                locals: { icon: scope.icon },
                skipHide: true,
                fullscreen: true,
                targetEvent: $event
            }).then(function (icon) {
                scope.icon = icon;
            });
        };

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        require: "^ngModel",
        link: linker,
        scope: {
            tbRequired: '=?'
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/components/material-icon-select.directive.js